import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Layout,
} from "antd";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import PageHeading from "../../../../components/common/PageHeading";
import { db, auth } from "../../../../firebase";
import "./inspection.css";
import { toast } from "react-hot-toast";
const { Header, Footer } = Layout;

const InspectionInfo = () => {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [inspectionLayout, setInspectionLayout] = useState(1);
  const [propertyList, setPropertyList] = useState([]);
  const [inspectionList, setInspectionList] = useState([]);

  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();

  }, [user, loading]);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setInspectionLayout(e.target.value);
  };

  const handleNewInspection = (id) => {
    navigate(`/inspection/${id}`);
  };

  const dateFormat = "YYYY-MM-DD";

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "properties");
        const snapshot = await getDocs(userRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const formattedData = fetchedData.map(item => ({
          value: item.id,
          label: item.propertyNameAddress.propertyName
        }));
        setPropertyList(formattedData);
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    };
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "inspectionsTemplates");
        const snapshot = await getDocs(userRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setInspectionList(
          fetchedData.map((item) => ({
            value: item.id,
            label: item.inspectionName,
          }))
        );
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    };
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);
  const onFinish = async (fieldsValue) => {
    const values = {
      ...fieldsValue,
      inspectionDate: fieldsValue["inspectionDate"]
        ? fieldsValue["inspectionDate"].format(dateFormat)
        : null,
    };

    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef,companyName);

    try {
      // Create a new collection named "inspections" under the "companyName" document
      const inspectionsCollectionRef = collection(companyDocRef, "inspections");
  
      // Add a new document to the "inspections" collection
      const result = await addDoc(inspectionsCollectionRef, {
        inspectionAddress: values.inspectionAddress || "",
        inspectionDate: values.inspectionDate || "",
        inspectionName: values.inspectionName || "",
        inspectionTemplate: values.inspectionTemplate || "",
        inspectionTemplateName: values.inspectionTemplateName || ""
      });
  
      toast.success("Inspection created successfully");
      handleNewInspection(result.id);

    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const defaultValues = {
    inspectionTemplate: 1
  }
  return (
    <div>
      <Header>
        <div className="inspection_topHeader" theme="dark">
          <h1>New Inspection</h1>
        </div>
      </Header>
      <Row justify="center">
        <Col span={12}>
          <PageHeading heading="INSPECTION INFORMATION" />

          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={defaultValues}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              label="Name"
              name="inspectionName"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Date"
              name="inspectionDate"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: "100%" }} />
            </Form.Item>

            <PageHeading heading="PROPERTY INFORMATION" />
            <Form.Item
              label="Address"
              name="inspectionAddress"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                allowClear
                showSearch
                placeholder="Search for property, unit or tenant"
                options={propertyList}
              />
            </Form.Item>

            <PageHeading heading="INSPECTION LAYOUT" />
            <Form.Item name="inspectionTemplate">
              <Radio.Group onChange={onChange} value={inspectionLayout}>
                <Space direction="vertical">
                  <Radio value={1}>Use default layout as starting point.</Radio>
                  <Radio value={2}>
                    Use existing inspection or template as starting point.
                  </Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="inspectionTemplateName">
              <Select
                allowClear
                showSearch
                disabled={inspectionLayout === 1 ? true : false}
                placeholder="Search for template, property, tenant or inspection"
                options={inspectionList}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Footer
        style={{
          textAlign: "center",
        }}
      >
        Copyright SayEagle © 2023
      </Footer>
    </div>
  );
};

export default InspectionInfo;
